export const ENGLISH_IQ_MAX_SECONDS = 900;
